export default __webpack_public_path__ + "./ico-logout-on.e8a9c7165ec7c0e03a3ab3d89db9a074.png";